import PublicLayout from "../components/PublicLayout";
import Hero from "../sections/Hero";
import Timeline from "../sections/Timeline";
import CeremonyMaster from "../sections/CeremonyMaster";
import MapSection from "../sections/MapSection";
import Lodging from "../sections/Lodging";
import GiftNote from "../sections/GiftNote";

export default function HomePage(): JSX.Element {
  return (
    <PublicLayout activePage="home">
      <Hero />
      <Timeline />
      <CeremonyMaster />
      <MapSection />
      <Lodging />
      <GiftNote />
    </PublicLayout>
  );
}
